// extracted by mini-css-extract-plugin
export default {"card":"Card_Donate_card__zd0mT"};